import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './EmptyState.css';
import Label from '../foundations/Label';
import EmptyStateIcon from '../../resources/svg/empty_state.svg';
import EmptyStateIconNoDevice from '../../resources/svg/empty_state_happy.svg';
import EmptyStateNoChartData from '../../resources/svg/empty_states_no_chart_data.svg';
import EmptyStateNoDataSource from '../../resources/svg/no_data_source.svg';
import EmptyStateStartAdding from '../../resources/svg/editing_dude.svg';
import EmptyStateNoData from '../../resources/svg/empty_state_no_data.svg';

const icons = {
    default: <EmptyStateIcon className={css.icon} />,
    noDevice: <EmptyStateIconNoDevice className={css.icon} />,
    happyPage: <EmptyStateIconNoDevice className={css.icon} />,
    noChartData: <EmptyStateNoChartData className={css.icon} />,
    noDataSource: <EmptyStateNoDataSource className={css.icon} />,
    noData: <EmptyStateNoData className={css.animate} />,
    startAdding: <EmptyStateStartAdding className={css.icon} />,
};

export const EMPTY_STATE_TEST_ID = 'empty-state';

const EmptyState = ({
    style = {},
    header = '',
    headerStyle = {},
    subHeader = '',
    headerTextReplace = {},
    subHeaderTextReplace = {},
    icon = 'default',
    customIcon = null,
    containerClass = '',
    children = null,
    onActionTriggered = () => {},
}) => {
    const handleClick = e => {
        if (!e.target || !e.target.attributes || !e.target.attributes['data-action']) {
            return;
        }
        const actionName = e.target.attributes['data-action'].value;
        const actionArgs = e.target.attributes['data-action-args']
            ? e.target.attributes['data-action-args'].value.split(',')
            : [];
        onActionTriggered(actionName, ...actionArgs);
    };

    return (
        <div
            data-testid={EMPTY_STATE_TEST_ID}
            className={classNames(css.container, containerClass)}
            style={style}
            onClick={handleClick}
        >
            {customIcon || icons[icon]}
            <div className={css.textContainer}>
                <Label
                    style={{ margin: 5, color: '#0F172A', fontSize: 16, fonWeight: 400, ...headerStyle }}
                    text={header}
                    textReplace={headerTextReplace}
                />
                {subHeader ? (
                    <Label
                        type="h4"
                        text={subHeader}
                        textReplace={subHeaderTextReplace}
                        style={{
                            marginTop: '10',
                            lineHeight: '1.8',
                            color: '#334155',
                            fontSize: 14,
                        }}
                    />
                ) : null}
                {children}
            </div>
        </div>
    );
};

EmptyState.propTypes = {
    style: PropTypes.objectOf(PropTypes.any),
    header: PropTypes.string,
    headerStyle: PropTypes.objectOf(PropTypes.any),
    headerTextReplace: PropTypes.objectOf(PropTypes.any),
    subHeader: PropTypes.string,
    subHeaderTextReplace: PropTypes.objectOf(PropTypes.any),
    icon: PropTypes.string,
    customIcon: PropTypes.objectOf(PropTypes.any),
    containerClass: PropTypes.string,
    onActionTriggered: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

export default EmptyState;
